import { AUTH_START, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT } from "../actions/authActions";

const initialState = {
    isFetching: false,
    isAuthenticated: !!localStorage.getItem("auth_token"),
    isAuthenticatedAth: !!localStorage.getItem("ath_auth_token"),
    authFailed: false,
    userSelectPlan: localStorage.getItem("planTier"),
    error: {}
};


export default function (state = initialState, action) {
 
    switch(action.type) {
        case AUTH_START:
            return {...state,
                isFetching:true,
                isAuthenticated:false,
            };

        case AUTH_SUCCESS:
            return {...state,
                isFetching:false,
                isAuthenticated:true,
                error: {},
                authFailed: false,
                token:JSON.parse(action.payload).token.token,
                userSelectPlan: JSON.parse(action.payload).tier,
            };

        case AUTH_ERROR:
            return {...state,
                isFetching:false,
                isAuthenticated:false,
                error: JSON.parse(action.payload),
                authFailed: true
            };

        case AUTH_LOGOUT:
            return {...state,
                isFetching:false,
                isAuthenticated:false,
                error: {},
                authFailed: false
            };

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducers.js